/**
 * CartRecoverPage — the destination of the abandoned-cart recovery email link
 * (`/cart/recover/:id`). It fetches the server-stored cart snapshot, rebuilds the
 * local cart from it (works even on a fresh device with empty localStorage), and
 * forwards the shopper to /cart to finish checking out.
 */
import { useEffect, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import api from '../utils/api';
import { useCartCtx } from '../App';

export default function CartRecoverPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { replaceCart } = useCartCtx();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;

    api.get(`/cart/recover/${id}`)
      .then(({ data }) => {
        const items = Array.isArray(data.items) ? data.items : [];
        if (!items.length) {
          toast.info('That cart is no longer available.');
          navigate('/shop', { replace: true });
          return;
        }
        replaceCart(items);
        toast.success('Your cart is back ✦');
        navigate('/cart', { replace: true });
      })
      .catch(() => {
        toast.error("We couldn't find that cart.");
        navigate('/shop', { replace: true });
      });
  }, [id, navigate, replaceCart]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <div className="text-center">
        <div className="inline-block h-8 w-8 animate-spin rounded-full border-4 border-tea-200 border-t-tea-600 mb-4" />
        <p className="text-gray-500">Bringing your cart back…</p>
      </div>
    </div>
  );
}
